module.exports = __webpack_public_path__ + "img/equipment.5d76dc47.svg";